export {
	CAREER_OFFER_EVENTS,
	CAREER_OFFER_GOALS,
	trackCareerOfferEvent,
	trackCareerOfferGoal,
	trackCareerOfferHit,
	type CareerOfferAttributionParameters,
	type CareerOfferEvent,
	type CareerOfferEventName,
	type CareerOfferForm,
	type CareerOfferGoal,
	type CareerOfferMetrica,
	type CareerOfferRouting,
	type CareerOfferTechnology,
	type CareerOfferUtmParameters,
	type CareerOfferVisitor,
} from './model/events.ts';
export {
	CAREER_OFFER_ATTRIBUTION_COOKIE,
	CAREER_OFFER_ATTRIBUTION_DAYS,
	extractCareerOfferUtm,
	updateCareerOfferAttribution,
	type CareerOfferAttribution,
	type CareerOfferTouch,
	type CareerOfferUtm,
} from './model/attribution.ts';
export {
	buildCareerOfferDestination,
	type CareerOfferDestinationContext,
} from './model/destination.ts';
export { toCareerOfferAttributionParameters } from './model/analytics-attribution.ts';
export {
	getCareerOfferRouteContext,
	getCareerOfferTechnology,
	type CareerOfferRouteContext,
} from './model/route-context.ts';
export { createCareerOfferImpressionTracker } from './model/impression.ts';
export { createCareerOfferFormTracker } from './model/form-tracker.ts';
export {
	CareerOfferAttributionProvider,
	useCareerOfferAttribution,
} from './ui/career-offer-attribution-provider';
export { CareerOfferPageEvent } from './ui/career-offer-page-event';
export { CareerOfferTrackedLink } from './ui/career-offer-tracked-link';
export { useCareerOfferAnalytics } from './ui/use-career-offer-analytics';
export {
	useCareerOfferPromoTracking,
	useCareerOfferVisibilityOnce,
} from './ui/use-career-offer-promo-tracking';
